/*
  Captcha component - migrated from jwt-bch-frontend
*/

import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react'
import { loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha'
import { Form, Button } from 'react-bootstrap'
import reload from '../assets/images/refresh-svgrepo-com.svg'

// Separate component for canvas that never re-renders
// Using a class component with shouldComponentUpdate is more reliable than functional component memoization
class CaptchaCanvas extends React.Component {
  componentDidMount () {
    // Initialize captcha after canvas is rendered
    const canvas = document.getElementById('canv')
    if (canvas) {
      loadCaptchaEnginge(6)
    }
  }

  shouldComponentUpdate () {
    return false // Never re-render this component
  }

  render () {
    const canvasHTML = '<div><canvas id="canv"></canvas><div><a id="reload_href" style="cursor: pointer; color: blue"></a></div></div>'
    return <div dangerouslySetInnerHTML={{ __html: canvasHTML }} />
  }
}

function Captcha ({ callback }) {
  const [value, setValue] = useState('')
  const [isValid, setIsValid] = useState(false)
  const callbackRef = useRef(callback)

  // Keep callback ref updated
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  const handleUpdate = useCallback((e) => {
    const inputValue = e.target.value
    setValue(inputValue)

    if (inputValue) {
      // Use validateCaptcha with false as second parameter to prevent reloading on validation failure
      // This is critical - without it, the captcha reloads every time validation fails (while typing)
      const valid = validateCaptcha(inputValue, false)
      setIsValid(valid)
      if (callbackRef.current) {
        callbackRef.current(null, valid)
      }
    } else {
      setIsValid(false)
      if (callbackRef.current) {
        callbackRef.current(null, false)
      }
    }
  }, [])

  const reloadCaptcha = useCallback(() => {
    loadCaptchaEnginge(6)
    setValue('')
    setIsValid(false)
    if (callbackRef.current) {
      callbackRef.current(null, false)
    }
  }, [])

  // Memoize the canvas component instance so it's only created once
  const canvasElement = useMemo(() => <CaptchaCanvas />, [])

  return (
    <div className='captcha-container mb-3'>
      <div className='d-flex align-items-center gap-2 mb-2'>
        {canvasElement}
        <Button
          variant='outline-secondary'
          size='sm'
          onClick={reloadCaptcha}
          type='button'
        >
          <img src={reload} alt='Reload' width={20} />
        </Button>
      </div>
      <Form.Control
        id='captchaValue'
        type='text'
        name='value'
        value={value}
        onChange={handleUpdate}
        placeholder='Enter captcha code'
        className={isValid ? 'is-valid' : value ? 'is-invalid' : ''}
      />
    </div>
  )
}

export default React.memo(Captcha)
